export default __webpack_public_path__ + "static/media/MMC_Regular.41e70884.woff2";